import{resolveHeroAnimationBindings,type ClipConfidence}from'./heroAnimationResolver'
import{getHeroCombatKit,type HeroCombatId,type SignatureAttackKind}from'./heroCombatIdentity'

export type RegisteredHeroClip={
  clip:string|null
  confidence:ClipConfidence
  score:number
}

const registry=new Map<HeroCombatId,ReadonlyMap<SignatureAttackKind,RegisteredHeroClip>>()

function asHeroId(heroId:string):HeroCombatId{
  return getHeroCombatKit(heroId).id
}

export function registerHeroAnimationInventory(heroId:string,clipNames:readonly string[]){
  const id=asHeroId(heroId)
  const bindings=resolveHeroAnimationBindings(id,clipNames)
  const map=new Map<SignatureAttackKind,RegisteredHeroClip>()
  for(const binding of bindings)map.set(binding.attack,{clip:binding.clip,confidence:binding.confidence,score:binding.score})
  registry.set(id,map)
  return bindings
}

export function registeredHeroClip(heroId:string,attack:SignatureAttackKind):RegisteredHeroClip{
  const id=asHeroId(heroId)
  return registry.get(id)?.get(attack)??{clip:null,confidence:'fallback',score:0}
}

export function clearHeroAnimationInventory(heroId?:string){
  if(heroId===undefined){registry.clear();return}
  registry.delete(asHeroId(heroId))
}

export function registeredHeroInventory(heroId:string):Readonly<Record<SignatureAttackKind,RegisteredHeroClip>>{
  const id=asHeroId(heroId),map=registry.get(id)
  return Object.freeze({
    light:map?.get('light')??{clip:null,confidence:'fallback',score:0},
    heavy:map?.get('heavy')??{clip:null,confidence:'fallback',score:0},
    special:map?.get('special')??{clip:null,confidence:'fallback',score:0},
    throw:map?.get('throw')??{clip:null,confidence:'fallback',score:0}
  })
}
